import { SyntheticEvent } from 'react'
import clsx from 'clsx'

import { Button, ButtonProps } from './Button'
import styles from './Button.module.scss'

export interface ButtonGroupOption extends Omit<ButtonProps, 'value'> {
    value: boolean | string | number
    label: string
}

export type Props = {
    value: boolean | string | number
    options: ButtonGroupOption[]
    onSelect: (value: boolean | string | number) => void
    className?: string
}

export const ButtonGroup = ({ options, value, className, onSelect, ...props }: Props) => {
    const handleClick = (event: SyntheticEvent, updatedValue: boolean | string | number) => {
        event.preventDefault()
        onSelect(updatedValue)
    }

    return (
        <div className={clsx(styles.buttonGroup, className)} {...props}>
            {options.map(({ value: _value, label, ...buttonProps }, index) => (
                <Button
                    key={index}
                    {...buttonProps}
                    size="small"
                    active={value === _value}
                    onClick={(event) => handleClick(event, _value)}
                >
                    {label}
                </Button>
            ))}
        </div>
    )
}
